import { UserDataService } from './../../../core/services/user-data.service';
import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
import { RouteStateService } from '../../../core/services/route-state.service';
import { User } from '../../../core/models/Other/UserReg'
import { notification } from '../../../core/models/notification.model';
import { UserIdleService } from 'angular-user-idle';
import { ThemeService } from '../../../core/services/theme.service';
import { UserContextService } from '../../../core/services/user-context.service';
//import { CookieService } from 'ngx-cookie-service';
import { CommonService } from 'src/app/core/services/common.service';
import { Params4Post } from 'src/app/core/models/General/Params4Post';
import { ReuseTabService } from 'src/app/core/reuse-tab';
//import { MenuDataService } from 'src/app/core/services/menu-data.service';
//import { saveAs } from 'file-saver';
import { ToastService } from 'src/app/core/services/toast.service';
import { ApplicationStateService } from 'src/app/core/services/application-state.service';
import { LocalStorageService } from 'src/app/core/services/local-storage.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html'
})
export class HeaderComponent implements OnInit {
  locale: string;
  language: any;
  user: User;
  companyInformation: any
  company: string = "";
  displayNotifications: boolean;
  queryExcel: boolean = false;
  query: string;
  timeout: number = 30;

  notifications: notification[];
  showUnrelease = false;
  showImport = false;
  companyCode = "";
  headerMobile: boolean = false;

  // displayLicense: boolean = false;
  // expiryDate: Date;
  // expiryDateDays: number;
  @Output() toggleMenubar: EventEmitter<any> = new EventEmitter();

  constructor(
    public translate: TranslateService,
    private router: Router,
    private routeStateService: RouteStateService,
    private userIdle: UserIdleService,
    private themeService: ThemeService,
    private userContextService: UserContextService,
    //private cookieService: CookieService,
    private userDataService: UserDataService,
    public commonService: CommonService,
    private reuseTabService: ReuseTabService,
    //private menuDataService: MenuDataService,
    private toastService: ToastService,
    private applicationStateService: ApplicationStateService,
    private localStorageService: LocalStorageService,
    ) {
    if(this.applicationStateService.getIsMobileResolution()){
      this.headerMobile = true;
    }
    else{
      this.headerMobile = false;
    }
    
    this.displayNotifications = false;

    let selectedTheme = this.localStorageService.getItem("selected-theme");
    if (selectedTheme) {
      this.selectTheme(selectedTheme);
    }
    this.locale = this.localStorageService.getItem("language");
    this.language = [
      { label: 'English', value: 'EN' },
      { label: 'Vietnamese (Tiếng Việt)', value: 'VN' },
      { label: 'Korean (한국어)', value: 'KR' },
      // { label: 'Japanese (漢字)', value: 'JP' },
      // { label: 'Chinese (汉语)', value: 'CN' },
      // { label: 'Khmer (ភាសាខ្មែរ)', value: 'KH' },
    ];
    // if(this.localStorageService.getItem("AccessFoGL").indexOf("/main/gl/unrelease") > -1) this.showUnrelease = true;
    // if(this.localStorageService.getItem("AccessFoSI").indexOf("/main/general/import_tool") > -1) this.showImport = true;

  }

  ngOnInit() {
    // this.companyInfor.getCompanyInfor()
    //   .subscribe((responseResult: any) => {
    //     this.companyInformation = responseResult.Data;
    //     this.company = this.companyInformation.CpnyName + " - Fiscal Year : " + this.companyInformation.FiscalYear;
    //   });
    this.user = this.userContextService.user$.getValue();
    this.notifications = [];
    for (let i = 1; i <= 5; i++) {
      let notificationObj = new notification("Message " + i, new Date(), null)
      this.notifications.push(notificationObj);
    }
    this.companyCode = this.localStorageService.getItem("cpnc");

    // this.expiryDateDays = this.localStorageService.getItem("lic");
    // this.expiryDate = new Date();
    // this.expiryDate.setDate(this.expiryDate.getDate() + Number(this.expiryDateDays));
    // if(Number(this.expiryDateDays) < 30){
    //   this.displayLicense = true;
    // }
  }

  // checkLic(){
  //   //Start watching for user inactivity.
  //   if(Number(this.expiryDateDays) < 5){
  //     this.userIdle.setConfigValues({ idle: 10, timeout: 300, ping: null })
  //   }
  //   else{
  //     this.userIdle.setConfigValues({ idle: 10, timeout: 1500, ping: null })
  //   }
    
  //   this.userIdle.startWatching();
    
  //   // Start watching when user idle is starting.
  //   this.userIdle.onTimerStart().subscribe();

  //   // Start watch when time is up.
  //   this.userIdle.onTimeout().subscribe(() => {
  //     this.displayLicense = true;
  //     this.userIdle.stopWatching();
  //   });
  // }
  // hideDialogLic(){
  //   this.checkLic();
  // }

  async logout() {
    // this.userIdle.stopWatching();
    this.userDataService.logout().subscribe((responseResult: any) => {
      if (responseResult.Data == true) {
        return;
      }
    });
    this.routeStateService.removeAll();
    this.userContextService.logout();
    // this.localStorageService.removeItem('active-menu');
    // this.localStorageService.removeItem("currentUser");
    // this.localStorageService.removeItem("language");
    // this.localStorageService.removeItem("selected-theme");
    // this.localStorageService.removeItem("selected-theme");
    this.localStorageService.clear();
    this.reuseTabService.clear();
    this.localStorageService.setItem("language", this.locale);
    this.router.navigate(['/login']);
  }

  showNotificationSidebar() {
    this.displayNotifications = true;
  }

  toggleMenu() {
    this.toggleMenubar.emit();
  }

  selectTheme(theme: string) {
    this.localStorageService.setItem("selected-theme", theme);
    this.themeService.selectTheme(theme);
  }

  onLanguageChange() {
    // the lang to use, if the lang isn't available, it will use the current loader to get them
    this.translate.use(this.locale);
    this.localStorageService.setItem("language", this.locale);
    this.changLanguageCookies();
  }
  changLanguageCookies() {
    this.commonService.getDataWithPost("api/general/ChangeLanguage", new Params4Post(this.locale)).toPromise().then((res: any) => {
    });
  }
  importTool() {
    this.router.navigate(['/main/general/import_tool']);
  }
  unRelease() {
    this.router.navigate(['/main/gl/unrelease']);
  }
  deleteImportList() {
    this.router.navigate(['/main/general/delete_import_list']);
  }
  deleteBatchList() {
    this.router.navigate(['/main/general/delete_batch']);
  }
  closeAllWindows() {
    this.reuseTabService.clear();
  }
  query2Excel() {
    this.queryExcel = true;
  }
  clickExport(){
    if(this.query == null || this.query.trim() == ''){
      this.toastService.addSingle('error', '', 'Entry Query');
      this.commonService.focusInput("query");
    }
    else if(this.timeout == null || this.timeout < 30){
      this.toastService.addSingle('error', '', 'Timeout should be greater than 30s to ensure request time');
      this.commonService.focusInput("timeout");
    }
    else{
    //   let param : Params4Post = new Params4Post(this.query, this.timeout.toString());
    //   this.commonService.downloadExcel(param,"api/gl/export-excel/query2excel").subscribe(res => {
    //     const data = new Blob([res], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
    //     saveAs(data,"data");
    //     this.queryExcel = false;
    //   },err => {
    //     this.toastService.addSingle('error', '', "Query không hợp lệ hoặc yêu cầu tới máy chủ bị lỗi")
    //     this.commonService.showError(this.messageService, err)
    // });
    }
  }
  restore(){
    this.commonService.getData("api/restore_default").subscribe((responseResult: any) => {
      if(responseResult.Data == true){
        this.toastService.addSingle('success', '', "Khôi phục dữ liệu thành công");
      }
      else{
        this.toastService.addSingle('error', '', responseResult.Message);
      }
      },err => {
          this.toastService.addSingle('error', '', "Yêu cầu tới máy chủ bị lỗi")
      });
  }
  guildLine(){
    // let url = this.commonService.getUrlCurrent();
    // let language = this.localStorageService.getItem("language");
    // if(url == "/main/dashboard"){
    //   if(language == "VN"){
    //     window.open('https://docs.ssaudit.com/','_blank')
    //   }
    //   else if(language == "KR"){
    //     window.open('https://docs.ssaudit.com/v/korean/','_blank')
    //   }
    //   else{
    //     window.open('https://docs.ssaudit.com/v/english/','_blank')
    //   }
    // }
    // else if(url.includes("/main/gl/")){
    //   if(url == "/main/gl/account_list"){
    //     if(language == "VN"){
    //       window.open('https://docs.ssaudit.com/thiet-lap-tai-khoan-but-toan-ket-chuyen-set-up/danh-muc-tai-khoan','_blank')
    //     }
    //     else if(language == "KR"){
    //       window.open('https://docs.ssaudit.com/v/korean/general-ledger/set-up-an-account-do-accounting-transfer-set-up','_blank')
    //     }
    //     else{
    //       window.open('https://docs.ssaudit.com/v/english/general-ledger/set-up-an-account-do-accounting-transfer-set-up','_blank')
    //     }
    //   }
    //   else if(url == "/main/gl/acct_class"){
    //     if(language == "VN"){
    //       window.open('https://docs.ssaudit.com/thiet-lap-tai-khoan-but-toan-ket-chuyen-set-up/danh-muc-nhom-tai-khoan','_blank')
    //     }
    //     else if(language == "KR"){
    //       window.open('https://docs.ssaudit.com/v/korean/general-ledger/set-up-an-account-do-accounting-transfer-set-up','_blank')
    //     }
    //     else{
    //       window.open('https://docs.ssaudit.com/v/english/general-ledger/set-up-an-account-do-accounting-transfer-set-up','_blank')
    //     }
    //   }
    //   else if(url == "/main/gl/setup_bs" || url == "/main/gl/glbs_description" || url == "/main/gl/glbs_code2" || url == "/main/gl/glbs_code1"){
    //     if(language == "VN"){
    //       window.open('https://docs.ssaudit.com/thiet-lap-tai-khoan-but-toan-ket-chuyen-set-up/thiet-lap-bang-can-doi-ke-toan','_blank')
    //     }
    //     else if(language == "KR"){
    //       window.open('https://docs.ssaudit.com/v/korean/general-ledger/set-up-an-account-do-accounting-transfer-set-up','_blank')
    //     }
    //     else{
    //       window.open('https://docs.ssaudit.com/v/english/general-ledger/set-up-an-account-do-accounting-transfer-set-up','_blank')
    //     }
    //   }
    //   else if(url == "/main/gl/glpost_description"){
    //     if(language == "VN"){
    //       window.open('https://docs.ssaudit.com/thiet-lap-tai-khoan-but-toan-ket-chuyen-set-up/khai-bao-but-toan-ket-chuyen-so-du-tai-khoan','_blank')
    //     }
    //     else if(language == "KR"){
    //       window.open('https://docs.ssaudit.com/v/korean/general-ledger/set-up-an-account-do-accounting-transfer-set-up','_blank')
    //     }
    //     else{
    //       window.open('https://docs.ssaudit.com/v/english/general-ledger/set-up-an-account-do-accounting-transfer-set-up','_blank')
    //     }
    //   }
    //   else if(url == "/main/gl/gl_tran" || url == "/main/gl/journal_tran_old"){
    //     if(language == "VN"){
    //       window.open('https://docs.ssaudit.com/nhap-du-lieu-input','_blank')
    //     }
    //     else if(language == "KR"){
    //       window.open('https://docs.ssaudit.com/v/korean/general-ledger/data-input','_blank')
    //     }
    //     else{
    //       window.open('https://docs.ssaudit.com/v/english/general-ledger/data-input','_blank')
    //     }
    //   }
    //   else if(url == "/main/gl/closing_period" || url == "/main/gl/unrelease" || url == "/main/gl/closing_by_month"){
    //     if(language == "VN"){
    //       window.open('https://docs.ssaudit.com/xu-ly-du-lieu-proccess','_blank')
    //     }
    //     else if(language == "KR"){
    //       window.open('https://docs.ssaudit.com/v/korean/general-ledger/data-processing','_blank')
    //     }
    //     else{
    //       window.open('https://docs.ssaudit.com/v/english/general-ledger/data-processing','_blank')
    //     }
    //   }
    //   else if(url == "/main/gl/gl_inquiry"){
    //     if(language == "VN"){
    //       window.open('https://docs.ssaudit.com/chi-tiet-hach-toan-inquiry','_blank')
    //     }
    //     else if(language == "KR"){
    //       window.open('https://docs.ssaudit.com/v/korean/general-ledger/inquiry','_blank')
    //     }
    //     else{
    //       window.open('https://docs.ssaudit.com/v/english/general-ledger/inquiry','_blank')
    //     }
    //   }
    //   else if(url.includes("/main/gl/report_gl")){
    //     if(language == "VN"){
    //       window.open('https://docs.ssaudit.com/ket-xuat-bao-cao-reports','_blank')
    //     }
    //     else if(language == "KR"){
    //       window.open('https://docs.ssaudit.com/v/korean/general-ledger/reports','_blank')
    //     }
    //     else{
    //       window.open('https://docs.ssaudit.com/v/english/general-ledger/reports','_blank')
    //     }
    //   }
    // }
    // else if(url.includes("/main/ap/")){
    //   if(url == "/main/ap/vendor_list"){
    //     if(language == "VN"){
    //       window.open('https://docs.ssaudit.com/account_payable/danh-muc-nha-cung-cap','_blank')
    //     }
    //     else if(language == "KR"){
    //       window.open('https://docs.ssaudit.com/v/korean/account-payable/set-up','_blank')
    //     }
    //     else{
    //       window.open('https://docs.ssaudit.com/v/english/account-payable/set-up','_blank')
    //     }
    //   }
    //   else if(url == "/main/ap/apvoucher"){
    //     if(language == "VN"){
    //       window.open('https://docs.ssaudit.com/account_payable/nhap-lieu-hoa-don-nha-cung-cap','_blank')
    //     }
    //     else if(language == "KR"){
    //       window.open('https://docs.ssaudit.com/v/korean/account-payable/input-invoice-of-vendors','_blank')
    //     }
    //     else{
    //       window.open('https://docs.ssaudit.com/v/english/account-payable/input-invoice-of-vendors','_blank')
    //     }
    //   }
    //   else if(url == "/main/ap/ap_release_batches"){
    //     if(language == "VN"){
    //       window.open('https://docs.ssaudit.com/account_payable/xu-ly-nhieu-chung-tu','_blank')
    //     }
    //     else if(language == "KR"){
    //       window.open('https://docs.ssaudit.com/v/korean/account-payable/proccess-ap-release-batches','_blank')
    //     }
    //     else{
    //       window.open('https://docs.ssaudit.com/v/english/account-payable/proccess-ap-release-batches','_blank')
    //     }
    //   }
    //   else if(url == "/main/ap/ap_inquiry"){
    //     if(language == "VN"){
    //       window.open('https://docs.ssaudit.com/account_payable/chi-tiet-hach-toan-phai-tra','_blank')
    //     }
    //     else if(language == "KR"){
    //       window.open('https://docs.ssaudit.com/v/korean/account-payable/inquiry','_blank')
    //     }
    //     else{
    //       window.open('https://docs.ssaudit.com/v/english/account-payable/inquiry','_blank')
    //     }
    //   }
    //   else if(url.includes("/main/ap/report_ap")){
    //     if(language == "VN"){
    //       window.open('https://docs.ssaudit.com/account_payable/bao-cao-reports','_blank')
    //     }
    //     else if(language == "KR"){
    //       window.open('https://docs.ssaudit.com/v/korean/account-payable/reports','_blank')
    //     }
    //     else{
    //       window.open('https://docs.ssaudit.com/v/english/account-payable/reports','_blank')
    //     }
    //   }
    // }
    // else if(url.includes("/main/ar/")){
    //   if(url == "/main/ar/customer_list"){
    //     if(language == "VN"){
    //       window.open('https://docs.ssaudit.com/account-receivable/danh-muc-khach-hang','_blank')
    //     }
    //     else if(language == "KR"){
    //       window.open('https://docs.ssaudit.com/v/korean/accounts-receivable/set-up','_blank')
    //     }
    //     else{
    //       window.open('https://docs.ssaudit.com/v/english/accounts-receivable/set-up','_blank')
    //     }
    //   }
    //   else if(url == "/main/ar/ar_invoice"){
    //     if(language == "VN"){
    //       window.open('https://docs.ssaudit.com/account-receivable/khoan-phai-thu','_blank')
    //     }
    //     else if(language == "KR"){
    //       window.open('https://docs.ssaudit.com/v/korean/accounts-receivable/input','_blank')
    //     }
    //     else{
    //       window.open('https://docs.ssaudit.com/v/english/accounts-receivable/input','_blank')
    //     }
    //   }
    //   else if(url == "/main/ar/release_batches"){
    //     if(language == "VN"){
    //       window.open('https://docs.ssaudit.com/account-receivable/xu-ly-nhieu-chung-tu','_blank')
    //     }
    //     else if(language == "KR"){
    //       window.open('https://docs.ssaudit.com/v/korean/accounts-receivable/process','_blank')
    //     }
    //     else{
    //       window.open('https://docs.ssaudit.com/v/english/accounts-receivable/process','_blank')
    //     }
    //   }
    //   else if(url == "/main/ar/ar_inquiry"){
    //     if(language == "VN"){
    //       window.open('https://docs.ssaudit.com/account-receivable/chi-tiet-hach-toan-khoan-phai-thu','_blank')
    //     }
    //     else if(language == "KR"){
    //       window.open('https://docs.ssaudit.com/v/korean/accounts-receivable/inquiry','_blank')
    //     }
    //     else{
    //       window.open('https://docs.ssaudit.com/v/english/accounts-receivable/inquiry','_blank')
    //     }
    //   }
    //   else if(url.includes("/main/ar/report_ar")){
    //     if(language == "VN"){
    //       window.open('https://docs.ssaudit.com/account-receivable/bao-cao-reports','_blank')
    //     }
    //     else if(language == "KR"){
    //       window.open('https://docs.ssaudit.com/v/korean/accounts-receivable/reports','_blank')
    //     }
    //     else{
    //       window.open('https://docs.ssaudit.com/v/english/accounts-receivable/reports','_blank')
    //     }
    //   }
    // }
    // else if(url.includes("/main/ca/")){
    //   if(url == "/main/ca/department" || url == "/main/ca/position_list" || url == "/main/ca/employee"){
    //     if(language == "VN"){
    //       window.open('https://docs.ssaudit.com/quan-ly-tien-mat-voi-module-ke-toan-tien-mat-ca/phan-he-cai-dat','_blank')
    //     }
    //     else if(language == "KR"){
    //       window.open('https://docs.ssaudit.com/v/korean/cash-management/setup','_blank')
    //     }
    //     else{
    //       window.open('https://docs.ssaudit.com/v/english/cash-management/setup','_blank')
    //     }
    //   }
    //   else if(url == "/main/ca/ca_payment" || url == "/main/ca/ca_receipt" || url == "/main/ca/bank_payment" || url == "/main/ca/bank_receipt"){
    //     if(language == "VN"){
    //       window.open('https://docs.ssaudit.com/quan-ly-tien-mat-voi-module-ke-toan-tien-mat-ca/phan-he-nhap-lieu','_blank')
    //     }
    //     else if(language == "KR"){
    //       window.open('https://docs.ssaudit.com/v/korean/cash-management/input','_blank')
    //     }
    //     else{
    //       window.open('https://docs.ssaudit.com/v/english/cash-management/input','_blank')
    //     }
    //   }
    //   else if(url == "/main/ca/release_batches" || url == "/main/ca/diff_exchange_rates"){
    //     if(language == "VN"){
    //       window.open('https://docs.ssaudit.com/quan-ly-tien-mat-voi-module-ke-toan-tien-mat-ca/phan-he-xu-ly','_blank')
    //     }
    //     else if(language == "KR"){
    //       window.open('https://docs.ssaudit.com/v/korean/cash-management/report','_blank')
    //     }
    //     else{
    //       window.open('','_blank')
    //     }
    //   }
    //   else if(url == "/main/ca/ca_inquiry"){
    //     if(language == "VN"){
    //       window.open('https://docs.ssaudit.com/quan-ly-tien-mat-voi-module-ke-toan-tien-mat-ca/phan-he-truy-van','_blank')
    //     }
    //     else if(language == "KR"){
    //       window.open('https://docs.ssaudit.com/v/korean/cash-management/undefined','_blank')
    //     }
    //     else{
    //       window.open('','_blank')
    //     }
    //   }
    //   else if(url.includes("/main/ca/report_ca")){
    //     if(language == "VN"){
    //       window.open('https://docs.ssaudit.com/quan-ly-tien-mat-voi-module-ke-toan-tien-mat-ca/phan-he-bao-cao','_blank')
    //     }
    //     else if(language == "KR"){
    //       window.open('https://docs.ssaudit.com/v/korean/cash-management/reports','_blank')
    //     }
    //     else{
    //       window.open('https://docs.ssaudit.com/v/english/cash-management/report','_blank')
    //     }
    //   }
    // }
    // else if(url.includes("/main/fa/")){
    //   if(url == "/main/fa/fa_group" || url == "/main/fa/fa_asset" || url == "/main/fa/dis_cost_list"){
    //     if(language == "VN"){
    //       window.open('https://docs.ssaudit.com/quan-ly-tai-san-co-dinh-va-chi-phi/cai-dat','_blank')
    //     }
    //     else if(language == "KR"){
    //       window.open('https://docs.ssaudit.com/v/korean/fixed-assets-and-expenses-management/set-up','_blank')
    //     }
    //     else{
    //       window.open('https://docs.ssaudit.com/v/english/fixed-assets-and-expenses-management/set-up','_blank')
    //     }
    //   }
    //   else if(url == "/main/fa/fa_disposal" || url == "/main/fa/fa_revalue"){
    //     if(language == "VN"){
    //       window.open('https://docs.ssaudit.com/quan-ly-tai-san-co-dinh-va-chi-phi/nhap-lieu','_blank')
    //     }
    //     else if(language == "KR"){
    //       window.open('https://docs.ssaudit.com/v/korean/fixed-assets-and-expenses-management/input','_blank')
    //     }
    //     else{
    //       window.open('https://docs.ssaudit.com/v/english/fixed-assets-and-expenses-management/input','_blank')
    //     }
    //   }
    //   else if(url == "/main/fa/fa_caldep" || url == "/main/fa/cal_allocation"){
    //     if(language == "VN"){
    //       window.open('https://docs.ssaudit.com/quan-ly-tai-san-co-dinh-va-chi-phi/xu-ly','_blank')
    //     }
    //     else if(language == "KR"){
    //       window.open('https://docs.ssaudit.com/v/korean/fixed-assets-and-expenses-management/process','_blank')
    //     }
    //     else{
    //       window.open('','_blank')
    //     }
    //   }
    //   else if(url == "/main/fa/fa_inquiry"){
    //     if(language == "VN"){
    //       window.open('https://docs.ssaudit.com/quan-ly-tai-san-co-dinh-va-chi-phi/thong-tin-tai-san','_blank')
    //     }
    //     else if(language == "KR"){
    //       window.open('https://docs.ssaudit.com/v/korean/fixed-assets-and-expenses-management/inquiry','_blank')
    //     }
    //     else{
    //       window.open('','_blank')
    //     }
    //   }
    //   else if(url.includes("/main/fa/report_fa")){
    //     if(language == "VN"){
    //       window.open('https://docs.ssaudit.com/quan-ly-tai-san-co-dinh-va-chi-phi/bao-cao','_blank')
    //     }
    //     else if(language == "KR"){
    //       window.open('https://docs.ssaudit.com/v/korean/fixed-assets-and-expenses-management/reports','_blank')
    //     }
    //     else{
    //       window.open('https://docs.ssaudit.com/v/english/fixed-assets-and-expenses-management/reports','_blank')
    //     }
    //   }
    // }
    // else if(url.includes("/main/inventory/")){
    //   if(url == "/main/inventory/category" || url == "/main/inventory/ic_class" || url == "/main/inventory/ic_site" ||
    //       url == "/main/inventory/ic_item" || url == "/main/inventory/ic_unit" || url == "/main/inventory/in_begin_balance" || url == "/main/inventory/update_inv_infor"){
    //     if(language == "VN"){
    //       window.open('https://docs.ssaudit.com/quan-ly-hang-ton-kho-voi-inventory/cai-dat','_blank')
    //     }
    //     else if(language == "KR"){
    //       window.open('https://docs.ssaudit.com/v/korean/inventory-management/setup','_blank')
    //     }
    //     else{
    //       window.open('https://docs.ssaudit.com/v/english/inventory-management/setup','_blank')
    //     }
    //   }
    //   else if(url == "/main/inventory/icrecr1" || url == "/main/inventory/icrecr2" || url == "/main/inventory/icrecr3" ||
    //     url == "/main/inventory/icrecr4" || url == "/main/inventory/icissues1" || url == "/main/inventory/icissues2" || 
    //     url == "/main/inventory/icissues3" || url == "/main/inventory/icissues4" || url == "/main/inventory/icadjustment"){
    //     if(language == "VN"){
    //       window.open('https://docs.ssaudit.com/quan-ly-hang-ton-kho-voi-inventory/nhap-lieu','_blank')
    //     }
    //     else if(language == "KR"){
    //       window.open('https://docs.ssaudit.com/v/korean/inventory-management/input','_blank')
    //     }
    //     else{
    //       window.open('https://docs.ssaudit.com/v/english/inventory-management/input','_blank')
    //     }
    //   }
    //   else if(url.includes("/main/inventory/process_inventory")){
    //     if(language == "VN"){
    //       window.open('https://docs.ssaudit.com/quan-ly-hang-ton-kho-voi-inventory/xu-ly','_blank')
    //     }
    //     else if(language == "KR"){
    //       window.open('https://docs.ssaudit.com/v/korean/inventory-management/processing','_blank')
    //     }
    //     else{
    //       window.open('https://docs.ssaudit.com/v/english/inventory-management/processing','_blank')
    //     }
    //   }
    //   else if(url.includes("/main/inventory/report_in")){
    //     if(language == "VN"){
    //       window.open('https://docs.ssaudit.com/quan-ly-hang-ton-kho-voi-inventory/bao-cao','_blank')
    //     }
    //     else if(language == "KR"){
    //       window.open('https://docs.ssaudit.com/v/korean/inventory-management/reports','_blank')
    //     }
    //     else{
    //       window.open('https://docs.ssaudit.com/v/english/inventory-management/reports','_blank')
    //     }
    //   }
    // }
    // else if(url.includes("/main/sa/")){
    //   if(url == "/main/sa/invoice" || url == "/main/sa/cancelinvoice" || url == "/main/sa/lostbadinvoice"){
    //     if(language == "VN"){
    //       window.open('https://docs.ssaudit.com/hoa-don-ban-hang/phan-he-cai-dat','_blank')
    //     }
    //     else if(language == "KR"){
    //       window.open('https://docs.ssaudit.com/v/korean/tax-invoice/setup','_blank')
    //     }
    //     else{
    //       window.open('https://docs.ssaudit.com/v/english/tax-invoice/setup','_blank')
    //     }
    //   }
    //   else if(url == "/main/sa/xuatkho_vcnb" || url == "/main/sa/listinvoice" || url == "/main/sa/check_invoice"){
    //     if(language == "VN"){
    //       window.open('https://docs.ssaudit.com/hoa-don-ban-hang/nhap-lieu','_blank')
    //     }
    //     else if(language == "KR"){
    //       window.open('https://docs.ssaudit.com/v/korean/tax-invoice/input','_blank')
    //     }
    //     else{
    //       window.open('https://docs.ssaudit.com/v/english/tax-invoice/input','_blank')
    //     }
    //   }
    //   else if(url.includes("/main/sa/report_sa")){
    //     if(language == "VN"){
    //       window.open('https://docs.ssaudit.com/hoa-don-ban-hang/bao-cao','_blank')
    //     }
    //     else if(language == "KR"){
    //       window.open('https://docs.ssaudit.com/v/korean/tax-invoice/reports','_blank')
    //     }
    //     else{
    //       window.open('https://docs.ssaudit.com/v/english/tax-invoice/reports','_blank')
    //     }
    //   }
    // }
    // else if(url.includes("/main/so/")){
    //   if(url == "/main/so/sale_order"){
    //     if(language == "VN"){
    //       window.open('https://docs.ssaudit.com/dat-hang-ban/nhap-lieu-don-dat-hang','_blank')
    //     }
    //     else if(language == "KR"){
    //       window.open('https://docs.ssaudit.com/v/korean/sale-order/input-sale-order','_blank')
    //     }
    //     else{
    //       window.open('https://docs.ssaudit.com/v/english/sale-order/input-sale-order','_blank')
    //     }
    //   }
    //   else if(url == "/main/so/releasebatches" || url == "/main/so/approvedbatches"){
    //     if(language == "VN"){
    //       window.open('https://docs.ssaudit.com/dat-hang-ban/xu-ly','_blank')
    //     }
    //     else if(language == "KR"){
    //       window.open('https://docs.ssaudit.com/v/korean/sale-order/process','_blank')
    //     }
    //     else{
    //       window.open('https://docs.ssaudit.com/v/english/sale-order/process','_blank')
    //     }
    //   }
    //   else if(url == "/main/so/rpt_saleorder"){
    //     if(language == "VN"){
    //       window.open('https://docs.ssaudit.com/dat-hang-ban/bao-cao-dat-hang','_blank')
    //     }
    //     else if(language == "KR"){
    //       window.open('https://docs.ssaudit.com/v/korean/sale-order/sale-order-report','_blank')
    //     }
    //     else{
    //       window.open('https://docs.ssaudit.com/v/english/sale-order/sale-order-report','_blank')
    //     }
    //   }
    // }
    // else if(url.includes("/main/po/")){
    //   if(url == "/main/po/purchase_order"){
    //     if(language == "VN"){
    //       window.open('https://docs.ssaudit.com/dat-mua/nhap-lieu','_blank')
    //     }
    //     else if(language == "KR"){
    //       window.open('https://docs.ssaudit.com/v/korean/purchase-order/input','_blank')
    //     }
    //     else{
    //       window.open('https://docs.ssaudit.com/v/english/purchase-order/input','_blank')
    //     }
    //   }
    //   else if(url == "/main/po/po_releasebatches" || url == "/main/po/approvedbatches"){
    //     if(language == "VN"){
    //       window.open('https://docs.ssaudit.com/dat-mua/xu-ly','_blank')
    //     }
    //     else if(language == "KR"){
    //       window.open('https://docs.ssaudit.com/v/korean/purchase-order/process','_blank')
    //     }
    //     else{
    //       window.open('https://docs.ssaudit.com/v/english/purchase-order/process','_blank')
    //     }
    //   }
    //   else if(url == "/main/po/rpt_puchaseorder"){
    //     if(language == "VN"){
    //       window.open('https://docs.ssaudit.com/dat-mua/bao-cao','_blank')
    //     }
    //     else if(language == "KR"){
    //       window.open('https://docs.ssaudit.com/v/korean/purchase-order/reports','_blank')
    //     }
    //     else{
    //       window.open('https://docs.ssaudit.com/v/english/purchase-order/reports','_blank')
    //     }
    //   }
    // }
    // else if(url.includes("/main/ei/")){
    //   if(url == "/main/ei/service_provider" || url == "/main/ei/service_account" || url == "/main/ei/user_account" || url == "/main/ei/serial_registration"){
    //     if(language == "VN"){
    //       window.open('https://docs.ssaudit.com/hoa-don-die-n-tu/cai-dat','_blank')
    //     }
    //     else if(language == "KR"){
    //       window.open('https://docs.ssaudit.com/v/korean/e-invoice/setup','_blank')
    //     }
    //     else{
    //       window.open('https://docs.ssaudit.com/v/english/e-invoice/setup','_blank')
    //     }
    //   }
    //   else if(url == "/main/ei/ei_input"){
    //     if(language == "VN"){
    //       window.open('https://docs.ssaudit.com/hoa-don-die-n-tu/nhap-lieu','_blank')
    //     }
    //     else if(language == "KR"){
    //       window.open('https://docs.ssaudit.com/v/korean/e-invoice/input','_blank')
    //     }
    //     else{
    //       window.open('https://docs.ssaudit.com/v/english/e-invoice/input','_blank')
    //     }
    //   }
    //   else if(url == "/main/ei/invoice_publishing" || url == "/main/ei/invoice_tracking"){
    //     if(language == "VN"){
    //       window.open('https://docs.ssaudit.com/hoa-don-die-n-tu/xu-ly','_blank')
    //     }
    //     else if(language == "KR"){
    //       window.open('https://docs.ssaudit.com/v/korean/e-invoice/processing','_blank')
    //     }
    //     else{
    //       window.open('https://docs.ssaudit.com/v/english/e-invoice/processing','_blank')
    //     }
    //   }
    // }
    // else if(url.includes("/main/general/") && url != "main/general/double_vouchers"){
    //   if(language == "VN"){
    //     window.open('https://docs.ssaudit.com/thong-tin-chung/nhap-lieu','_blank')
    //   }
    //   else if(language == "KR"){
    //     window.open('https://docs.ssaudit.com/v/korean/shared-informations/input','_blank')
    //   }
    //   else{
    //     window.open('https://docs.ssaudit.com/v/english/shared-informations/input','_blank')
    //   }
    // }
    // else if(url.includes("/main/use_full/") || url == "main/general/double_vouchers"){
    //   if(language == "VN"){
    //     window.open('https://docs.ssaudit.com/tie-n-ich/tien-ich','_blank')
    //   }
    //   else if(language == "KR"){
    //     window.open('https://docs.ssaudit.com/v/korean/usefull/usefull','_blank')
    //   }
    //   else{
    //     window.open('https://docs.ssaudit.com/v/english/useful/usefull','_blank')
    //   }
    // }
    // else if(url.includes("/main/setup_tools/")){
    //   if(language == "VN"){
    //     window.open('https://docs.ssaudit.com/ca-i-da-t-chung/bao-mat','_blank')
    //   }
    //   else if(language == "KR"){
    //     window.open('https://docs.ssaudit.com/v/korean/setup-tool/security','_blank')
    //   }
    //   else{
    //     window.open('https://docs.ssaudit.com/v/english/setup-tool/security','_blank')
    //   }
    // }
    // else if(url.includes("/main/bg/")){
      
    // }
  }
}
